// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  CoachOfferingsOfferingPackageFragmentDoc,
  CoachOfferingsCoachFragmentDoc,
} from './CoachOfferings.generated';
import { CoachGroupClassesAllEventsFragmentDoc } from './CoachGroupClasses.generated';
import { CoachExperienceProfessionalExperienceFragmentDoc } from './CoachExperience.generated';
import { CoachEducationEducationFragmentDoc } from './CoachEducation.generated';
import { CoachCategoriesCategoryInformationFragmentDoc } from './CoachCategories.generated';
import { CoachBottomMessageCtaCoachFragmentDoc } from './CoachBottomMessageCTA.generated';
import { CoachInfoCoachFragmentDoc } from './CoachInfo.generated';
import { SaveCoachButtonSaveCoachFragmentDoc } from './SaveCoachButton.generated';
import { CoachBioCoachFragmentDoc } from './CoachBio.generated';
import { CoachWhyICoachCoachFragmentDoc } from './CoachWhyICoach.generated';
import { CoachQualificationsCoachFragmentDoc } from './CoachQualifications.generated';
import { CoachReviewsCoachFragmentDoc } from './CoachReviews.generated';
import { AllCoachReviewsModalCoachFragmentDoc } from '../modals/__generated-gql-types__/AllCoachReviewsModal.generated';
import { CoachMessageCtaCoachFragmentDoc } from './CoachMessageCTA.generated';
import { StructuredCoachDataCoachFragmentDoc } from '../../../utils/__generated-gql-types__/structuredCoachData.generated';
import { ReviewModalReviewFragmentDoc } from '../../review/modals/__generated-gql-types__/ReviewModal.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CoachPageCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  bio?: string | null;
  hourlyRate?: number | null;
  averageReviewRate: number;
  reviewTotal: number;
  averageFirstResponseLatency?: number | null;
  visibility: Types.CoachVisibility;
  tier: Types.SkuTier;
  isSuperCoach?: boolean | null;
  totalCoachingMinutes: number;
  whyICoach?: string | null;
  lelandPlusContributor: boolean;
  couldScheduleIntro?: boolean | null;
  headline?: string | null;
  isSaved?: boolean | null;
  professionalCoach: boolean;
  openToInternational: boolean;
  averageKnowledgeReviewRate: number;
  averageValueReviewRate: number;
  averageResponsivenessReviewRate: number;
  averageSupportivenessReviewRate: number;
  everHadCoachingSessionWithCoach?: boolean | null;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
    linkedInLink?: string | null;
  };
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    qualifications?: string | null;
    testScore?: number | null;
    headline?: string | null;
    isHidden: boolean;
    id: string;
    experienceLevel?: number | null;
    customersCoached?: number | null;
    category: {
      __typename?: 'Category';
      id: string;
      slug: string;
      goal: Types.GoalName;
      name: string;
      subCategoryTitle?: string | null;
      subCategoryList?: Array<{
        __typename?: 'SubCategory';
        id: string;
        name: string;
      }> | null;
    };
    coachingFocusList?: Array<{
      __typename?: 'CoachingFocus';
      id: string;
      name: string;
      slug: string;
    }> | null;
    coach: {
      __typename?: 'Coach';
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        pictureLink?: string | null;
      };
    };
  }> | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    blockedByCoach: boolean;
    paidTimeInMinute?: number | null;
    review?: {
      __typename?: 'Review';
      id: string;
      anonymous: boolean;
      rate: number;
      overallRate: number;
      headline?: string | null;
      comment?: string | null;
      guestReviewer?: string | null;
      reviewedAt: number;
      applicant?: {
        __typename?: 'Applicant';
        id: string;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          pictureLink?: string | null;
          email: string;
        };
      } | null;
      coach: {
        __typename?: 'Coach';
        id: string;
        slug: string;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          pictureLink?: string | null;
          email: string;
        };
      };
      categoryReviews?: Array<{
        __typename?: 'CategoryReview';
        responsiveness?: number | null;
        supportiveness?: number | null;
        knowledge?: number | null;
        value?: number | null;
        category: {
          __typename?: 'Category';
          id: string;
          name: string;
          slug: string;
          isFeatured: boolean;
          goal: Types.GoalName;
          coachingFocusList?: Array<{
            __typename?: 'CoachingFocus';
            id: string;
            name: string;
          }> | null;
        };
        subCategoryList?: Array<{
          __typename?: 'SubCategory';
          name: string;
        }> | null;
      }> | null;
      outcomes?: Array<
        | {
            __typename?: 'JobOfferInfo';
            company: {
              __typename?: 'Company';
              id?: string | null;
              name: string;
              logoLink?: string | null;
            };
          }
        | {
            __typename?: 'SchoolAdmissionInfo';
            status?: Types.SchoolAdmissionStatus | null;
            school: {
              __typename?: 'School';
              id: string;
              name: string;
              logoLink?: string | null;
            };
          }
        | { __typename?: 'TestScoreV2'; score: number; testName: string }
      > | null;
      mostRecentOrder?: {
        __typename?: 'Order';
        id: string;
        classOrder?: {
          __typename?: 'ClassOrder';
          coachingSession: {
            __typename?: 'CoachingSession';
            id: string;
            content:
              | { __typename: 'BootcampSession' }
              | { __typename: 'Class'; id: string; name?: string | null }
              | { __typename: 'EventSession' }
              | { __typename: 'OneOnOneSession' };
          };
        } | null;
        packageOrder?: {
          __typename?: 'OfferingPackage';
          id: string;
          name: string;
          visibility: Types.PackageVisibility;
          category?: {
            __typename?: 'Category';
            id: string;
            name: string;
          } | null;
        } | null;
      } | null;
      mostRecentClassSession?: {
        __typename?: 'CoachingSession';
        id: string;
        content:
          | { __typename: 'BootcampSession' }
          | {
              __typename: 'Class';
              id: string;
              name?: string | null;
              isFreeEvent?: boolean | null;
            }
          | { __typename: 'EventSession' }
          | { __typename: 'OneOnOneSession' };
      } | null;
    } | null;
    categories?: Array<{
      __typename?: 'Category';
      id: string;
      slug: string;
    }> | null;
    upcomingEnrolledSessions?: Array<{
      __typename?: 'CoachingSession';
      id: string;
      canceled: boolean;
      summary?: string | null;
      hasRecording: boolean;
      additionalTimeToBuy: number;
      name: string;
      sessionType: Types.CoachingSessionType;
      durationInMinute: number;
      startAt: number;
      endAt: number;
      content:
        | {
            __typename: 'BootcampSession';
            bootcamp: { __typename?: 'Bootcamp'; id: string; slug: string };
          }
        | {
            __typename: 'Class';
            id: string;
            slug?: string | null;
            isFreeEvent?: boolean | null;
          }
        | { __typename: 'EventSession' }
        | {
            __typename: 'OneOnOneSession';
            title: string;
            order?: { __typename?: 'Order'; status: Types.OrderStatus } | null;
            introOrder?: {
              __typename?: 'Order';
              introCall?: {
                __typename?: 'IntroCall';
                packages?: Array<{
                  __typename?: 'OfferingPackage';
                  id: string;
                }> | null;
              } | null;
            } | null;
          };
      coach: {
        __typename?: 'Coach';
        id: string;
        user: { __typename?: 'User'; id: string; firstName: string };
      };
      attendees?: Array<{
        __typename?: 'Applicant';
        id: string;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          pictureLink?: string | null;
        };
      }> | null;
      recurringSession?: {
        __typename?: 'RecurringSession';
        id: string;
        formattedCadence: string;
        cadence: {
          __typename?: 'RecurringCadence';
          type: Types.RecurrenceType;
          dayOfWeek?: Types.DayOfWeek | null;
          weekOfMonth?: number | null;
          interval?: number | null;
          isLastWeekOfMonth?: boolean | null;
          startHour: number;
          startMinute: number;
          durationMinutes: number;
        };
      } | null;
    }> | null;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
  packages?: Array<{
    __typename?: 'OfferingPackage';
    status: Types.PackageStatus;
    lelandPackageVisibility?: Types.PackageVisibility | null;
    id: string;
    slug?: string | null;
    name: string;
    subTitle?: string | null;
    isUniversalPackage: boolean;
    imageLink?: string | null;
    prices?: Array<{
      __typename?: 'OfferingPackagePrice';
      sku?: string | null;
      price: number;
      packageCoachingTime?: {
        __typename?: 'PackageCoachingTime';
        exactTimeInMinute?: number | null;
        estimate?: {
          __typename?: 'IntRange';
          start?: number | null;
          end?: number | null;
        } | null;
      } | null;
    }> | null;
    category?: { __typename?: 'Category'; id: string; slug: string } | null;
    coach: { __typename?: 'Coach'; id: string; slug: string };
  }> | null;
  groupClassesAndShindigs: Array<
    | {
        __typename: 'Class';
        slug?: string | null;
        name?: string | null;
        imageLink?: string | null;
        price?: number | null;
        isUserOnDiscoveryList?: boolean | null;
        isFreeEvent?: boolean | null;
        classId: string;
        coach?: {
          __typename?: 'Coach';
          id: string;
          user: { __typename?: 'User'; id: string; firstName: string };
        } | null;
        upcomingSessionsV2?: Array<{
          __typename?: 'CoachingSession';
          id: string;
          startAt: number;
          durationInMinute: number;
        }> | null;
      }
    | {
        __typename: 'Shindig';
        imageLink?: string | null;
        date: number;
        link: string;
        numGuests?: number | null;
        durationInMinute: number;
        shindigId: string;
        shindigName: string;
      }
  >;
  schoolAdmissionInfoList?: Array<{
    __typename?: 'SchoolAdmissionInfo';
    status?: Types.SchoolAdmissionStatus | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  companiesAdmitted?: Array<{
    __typename?: 'Company';
    id?: string | null;
    name: string;
    domain?: string | null;
    logoLink?: string | null;
  }> | null;
  mostRecentOrder?: {
    __typename?: 'Order';
    id: string;
    hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
  } | null;
  professionalExperiences?: Array<{
    __typename?: 'ProfessionalExperience';
    experienceType?: Types.ExperienceType | null;
    isFeatured?: boolean | null;
    description?: string | null;
    company: {
      __typename?: 'Company';
      id?: string | null;
      name: string;
      domain?: string | null;
      logoLink?: string | null;
    };
    endAt?: {
      __typename?: 'MonthYear';
      year: number;
      month?: number | null;
    } | null;
    jobTitle?: { __typename?: 'JobTitle'; id: string; name: string } | null;
    startAt: { __typename?: 'MonthYear'; month?: number | null; year: number };
  }> | null;
  educationExperiences?: Array<{
    __typename?: 'Education';
    admissionCommittee: boolean;
    isFeatured?: boolean | null;
    degree?: string | null;
    description?: string | null;
    major?: string | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
    startAt?: { __typename?: 'MonthYear'; year: number } | null;
    endAt?: { __typename?: 'MonthYear'; year: number } | null;
  }> | null;
  matchedCoach?: {
    __typename?: 'MatchedCoach';
    id: string;
    status: Types.MatchedCoachStatus;
  } | null;
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
    detail?: string | null;
    defaultAvailability?: {
      __typename?: 'DefaultAvailability';
      totalInMinute: number;
    } | null;
  } | null;
  badges?: Array<{
    __typename?: 'Badge';
    id: string;
    type: Types.BadgeType;
    categoryUrn?: string | null;
  }> | null;
  outcomes?: Array<
    | {
        __typename?: 'CareerOutcomeSummary';
        number: number;
        companies: Array<{
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'SchoolOutcomeSummary';
        number: number;
        schools: Array<{
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'TestOutcomeSummary';
        scoreRange?: string | null;
        number: number;
        category: { __typename?: 'Category'; id: string; name: string };
      }
  > | null;
  geoLocation?: { __typename?: 'GeoLocation'; address: string } | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
    cycles?: Array<{
      __typename?: 'SubscriptionCycle';
      timeInMinute: number;
      start?: number | null;
      end?: number | null;
    }> | null;
  } | null;
  introVideo?: {
    __typename?: 'VideoLink';
    duration: string;
    thumbnailLink: string;
    youtubeId: string;
  } | null;
};

export type CoachPageUserFragment = {
  __typename?: 'User';
  id: string;
  applicant?: {
    __typename?: 'Applicant';
    id: string;
    hasUnassignedTrialOrder?: boolean | null;
  } | null;
};

export type CoachPageGetCoachBySlugQueryVariables = Types.Exact<{
  coachSlug: Types.Scalars['String']['input'];
  categorySlugOrUrn?: Types.InputMaybe<Types.Scalars['String']['input']>;
  ignoreFullSessions?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type CoachPageGetCoachBySlugQuery = {
  __typename?: 'Query';
  coachBySlug?: {
    __typename?: 'Coach';
    id: string;
    slug: string;
    bio?: string | null;
    hourlyRate?: number | null;
    averageReviewRate: number;
    reviewTotal: number;
    averageFirstResponseLatency?: number | null;
    visibility: Types.CoachVisibility;
    tier: Types.SkuTier;
    isSuperCoach?: boolean | null;
    totalCoachingMinutes: number;
    whyICoach?: string | null;
    lelandPlusContributor: boolean;
    couldScheduleIntro?: boolean | null;
    headline?: string | null;
    isSaved?: boolean | null;
    professionalCoach: boolean;
    openToInternational: boolean;
    averageKnowledgeReviewRate: number;
    averageValueReviewRate: number;
    averageResponsivenessReviewRate: number;
    averageSupportivenessReviewRate: number;
    everHadCoachingSessionWithCoach?: boolean | null;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      linkedInLink?: string | null;
    };
    categoryInformationList?: Array<{
      __typename?: 'CategoryInformation';
      qualifications?: string | null;
      testScore?: number | null;
      headline?: string | null;
      isHidden: boolean;
      id: string;
      experienceLevel?: number | null;
      customersCoached?: number | null;
      category: {
        __typename?: 'Category';
        id: string;
        slug: string;
        goal: Types.GoalName;
        name: string;
        subCategoryTitle?: string | null;
        subCategoryList?: Array<{
          __typename?: 'SubCategory';
          id: string;
          name: string;
        }> | null;
      };
      coachingFocusList?: Array<{
        __typename?: 'CoachingFocus';
        id: string;
        name: string;
        slug: string;
      }> | null;
      coach: {
        __typename?: 'Coach';
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          pictureLink?: string | null;
        };
      };
    }> | null;
    coachingRelationship?: {
      __typename?: 'CoachingRelationship';
      id: string;
      blockedByCoach: boolean;
      paidTimeInMinute?: number | null;
      review?: {
        __typename?: 'Review';
        id: string;
        anonymous: boolean;
        rate: number;
        overallRate: number;
        headline?: string | null;
        comment?: string | null;
        guestReviewer?: string | null;
        reviewedAt: number;
        applicant?: {
          __typename?: 'Applicant';
          id: string;
          user: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            pictureLink?: string | null;
            email: string;
          };
        } | null;
        coach: {
          __typename?: 'Coach';
          id: string;
          slug: string;
          user: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            pictureLink?: string | null;
            email: string;
          };
        };
        categoryReviews?: Array<{
          __typename?: 'CategoryReview';
          responsiveness?: number | null;
          supportiveness?: number | null;
          knowledge?: number | null;
          value?: number | null;
          category: {
            __typename?: 'Category';
            id: string;
            name: string;
            slug: string;
            isFeatured: boolean;
            goal: Types.GoalName;
            coachingFocusList?: Array<{
              __typename?: 'CoachingFocus';
              id: string;
              name: string;
            }> | null;
          };
          subCategoryList?: Array<{
            __typename?: 'SubCategory';
            name: string;
          }> | null;
        }> | null;
        outcomes?: Array<
          | {
              __typename?: 'JobOfferInfo';
              company: {
                __typename?: 'Company';
                id?: string | null;
                name: string;
                logoLink?: string | null;
              };
            }
          | {
              __typename?: 'SchoolAdmissionInfo';
              status?: Types.SchoolAdmissionStatus | null;
              school: {
                __typename?: 'School';
                id: string;
                name: string;
                logoLink?: string | null;
              };
            }
          | { __typename?: 'TestScoreV2'; score: number; testName: string }
        > | null;
        mostRecentOrder?: {
          __typename?: 'Order';
          id: string;
          classOrder?: {
            __typename?: 'ClassOrder';
            coachingSession: {
              __typename?: 'CoachingSession';
              id: string;
              content:
                | { __typename: 'BootcampSession' }
                | { __typename: 'Class'; id: string; name?: string | null }
                | { __typename: 'EventSession' }
                | { __typename: 'OneOnOneSession' };
            };
          } | null;
          packageOrder?: {
            __typename?: 'OfferingPackage';
            id: string;
            name: string;
            visibility: Types.PackageVisibility;
            category?: {
              __typename?: 'Category';
              id: string;
              name: string;
            } | null;
          } | null;
        } | null;
        mostRecentClassSession?: {
          __typename?: 'CoachingSession';
          id: string;
          content:
            | { __typename: 'BootcampSession' }
            | {
                __typename: 'Class';
                id: string;
                name?: string | null;
                isFreeEvent?: boolean | null;
              }
            | { __typename: 'EventSession' }
            | { __typename: 'OneOnOneSession' };
        } | null;
      } | null;
      categories?: Array<{
        __typename?: 'Category';
        id: string;
        slug: string;
      }> | null;
      upcomingEnrolledSessions?: Array<{
        __typename?: 'CoachingSession';
        id: string;
        canceled: boolean;
        summary?: string | null;
        hasRecording: boolean;
        additionalTimeToBuy: number;
        name: string;
        sessionType: Types.CoachingSessionType;
        durationInMinute: number;
        startAt: number;
        endAt: number;
        content:
          | {
              __typename: 'BootcampSession';
              bootcamp: { __typename?: 'Bootcamp'; id: string; slug: string };
            }
          | {
              __typename: 'Class';
              id: string;
              slug?: string | null;
              isFreeEvent?: boolean | null;
            }
          | { __typename: 'EventSession' }
          | {
              __typename: 'OneOnOneSession';
              title: string;
              order?: {
                __typename?: 'Order';
                status: Types.OrderStatus;
              } | null;
              introOrder?: {
                __typename?: 'Order';
                introCall?: {
                  __typename?: 'IntroCall';
                  packages?: Array<{
                    __typename?: 'OfferingPackage';
                    id: string;
                  }> | null;
                } | null;
              } | null;
            };
        coach: {
          __typename?: 'Coach';
          id: string;
          user: { __typename?: 'User'; id: string; firstName: string };
        };
        attendees?: Array<{
          __typename?: 'Applicant';
          id: string;
          user: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            pictureLink?: string | null;
          };
        }> | null;
        recurringSession?: {
          __typename?: 'RecurringSession';
          id: string;
          formattedCadence: string;
          cadence: {
            __typename?: 'RecurringCadence';
            type: Types.RecurrenceType;
            dayOfWeek?: Types.DayOfWeek | null;
            weekOfMonth?: number | null;
            interval?: number | null;
            isLastWeekOfMonth?: boolean | null;
            startHour: number;
            startMinute: number;
            durationMinutes: number;
          };
        } | null;
      }> | null;
      customerSubscription?: {
        __typename?: 'CustomerSubscription';
        id: string;
        sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
      } | null;
    } | null;
    packages?: Array<{
      __typename?: 'OfferingPackage';
      status: Types.PackageStatus;
      lelandPackageVisibility?: Types.PackageVisibility | null;
      id: string;
      slug?: string | null;
      name: string;
      subTitle?: string | null;
      isUniversalPackage: boolean;
      imageLink?: string | null;
      prices?: Array<{
        __typename?: 'OfferingPackagePrice';
        sku?: string | null;
        price: number;
        packageCoachingTime?: {
          __typename?: 'PackageCoachingTime';
          exactTimeInMinute?: number | null;
          estimate?: {
            __typename?: 'IntRange';
            start?: number | null;
            end?: number | null;
          } | null;
        } | null;
      }> | null;
      category?: { __typename?: 'Category'; id: string; slug: string } | null;
      coach: { __typename?: 'Coach'; id: string; slug: string };
    }> | null;
    groupClassesAndShindigs: Array<
      | {
          __typename: 'Class';
          slug?: string | null;
          name?: string | null;
          imageLink?: string | null;
          price?: number | null;
          isUserOnDiscoveryList?: boolean | null;
          isFreeEvent?: boolean | null;
          classId: string;
          coach?: {
            __typename?: 'Coach';
            id: string;
            user: { __typename?: 'User'; id: string; firstName: string };
          } | null;
          upcomingSessionsV2?: Array<{
            __typename?: 'CoachingSession';
            id: string;
            startAt: number;
            durationInMinute: number;
          }> | null;
        }
      | {
          __typename: 'Shindig';
          imageLink?: string | null;
          date: number;
          link: string;
          numGuests?: number | null;
          durationInMinute: number;
          shindigId: string;
          shindigName: string;
        }
    >;
    schoolAdmissionInfoList?: Array<{
      __typename?: 'SchoolAdmissionInfo';
      status?: Types.SchoolAdmissionStatus | null;
      school: {
        __typename?: 'School';
        id: string;
        name: string;
        logoLink?: string | null;
      };
    }> | null;
    companiesAdmitted?: Array<{
      __typename?: 'Company';
      id?: string | null;
      name: string;
      domain?: string | null;
      logoLink?: string | null;
    }> | null;
    mostRecentOrder?: {
      __typename?: 'Order';
      id: string;
      hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
    } | null;
    professionalExperiences?: Array<{
      __typename?: 'ProfessionalExperience';
      experienceType?: Types.ExperienceType | null;
      isFeatured?: boolean | null;
      description?: string | null;
      company: {
        __typename?: 'Company';
        id?: string | null;
        name: string;
        domain?: string | null;
        logoLink?: string | null;
      };
      endAt?: {
        __typename?: 'MonthYear';
        year: number;
        month?: number | null;
      } | null;
      jobTitle?: { __typename?: 'JobTitle'; id: string; name: string } | null;
      startAt: {
        __typename?: 'MonthYear';
        month?: number | null;
        year: number;
      };
    }> | null;
    educationExperiences?: Array<{
      __typename?: 'Education';
      admissionCommittee: boolean;
      isFeatured?: boolean | null;
      degree?: string | null;
      description?: string | null;
      major?: string | null;
      school: {
        __typename?: 'School';
        id: string;
        name: string;
        logoLink?: string | null;
      };
      startAt?: { __typename?: 'MonthYear'; year: number } | null;
      endAt?: { __typename?: 'MonthYear'; year: number } | null;
    }> | null;
    matchedCoach?: {
      __typename?: 'MatchedCoach';
      id: string;
      status: Types.MatchedCoachStatus;
    } | null;
    availability?: {
      __typename?: 'CoachAvailability';
      nextAvailableAt?: number | null;
      detail?: string | null;
      defaultAvailability?: {
        __typename?: 'DefaultAvailability';
        totalInMinute: number;
      } | null;
    } | null;
    badges?: Array<{
      __typename?: 'Badge';
      id: string;
      type: Types.BadgeType;
      categoryUrn?: string | null;
    }> | null;
    outcomes?: Array<
      | {
          __typename?: 'CareerOutcomeSummary';
          number: number;
          companies: Array<{
            __typename?: 'Company';
            id?: string | null;
            name: string;
            logoLink?: string | null;
          }>;
        }
      | {
          __typename?: 'SchoolOutcomeSummary';
          number: number;
          schools: Array<{
            __typename?: 'School';
            id: string;
            name: string;
            logoLink?: string | null;
          }>;
        }
      | {
          __typename?: 'TestOutcomeSummary';
          scoreRange?: string | null;
          number: number;
          category: { __typename?: 'Category'; id: string; name: string };
        }
    > | null;
    geoLocation?: { __typename?: 'GeoLocation'; address: string } | null;
    coachingTimeSummary?: {
      __typename?: 'CoachingTimeSummary';
      availableTime: number;
      hasUnlimitedPackage: boolean;
      cycles?: Array<{
        __typename?: 'SubscriptionCycle';
        timeInMinute: number;
        start?: number | null;
        end?: number | null;
      }> | null;
    } | null;
    introVideo?: {
      __typename?: 'VideoLink';
      duration: string;
      thumbnailLink: string;
      youtubeId: string;
    } | null;
  } | null;
};

export type CoachPageGetHydratedCoachBySlugQueryVariables = Types.Exact<{
  coachSlug: Types.Scalars['String']['input'];
}>;

export type CoachPageGetHydratedCoachBySlugQuery = {
  __typename?: 'Query';
  coachBySlug?: {
    __typename?: 'Coach';
    id: string;
    isSaved?: boolean | null;
  } | null;
};

export type CoachPageGetHourlyOrderQueryVariables = Types.Exact<{
  id: Types.Scalars['OrderUrn']['input'];
}>;

export type CoachPageGetHourlyOrderQuery = {
  __typename?: 'Query';
  order?: {
    __typename?: 'Order';
    id: string;
    hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
  } | null;
};

export type CoachPageGetUserQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CoachPageGetUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    applicant?: {
      __typename?: 'Applicant';
      id: string;
      hasUnassignedTrialOrder?: boolean | null;
    } | null;
  } | null;
};

export type CoachPageReviewFragment = {
  __typename?: 'Review';
  id: string;
  anonymous: boolean;
  rate: number;
  overallRate: number;
  headline?: string | null;
  comment?: string | null;
  guestReviewer?: string | null;
  reviewedAt: number;
  applicant?: {
    __typename?: 'Applicant';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      email: string;
    };
  } | null;
  coach: {
    __typename?: 'Coach';
    id: string;
    slug: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      email: string;
    };
  };
  categoryReviews?: Array<{
    __typename?: 'CategoryReview';
    responsiveness?: number | null;
    supportiveness?: number | null;
    knowledge?: number | null;
    value?: number | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      slug: string;
      isFeatured: boolean;
      goal: Types.GoalName;
      coachingFocusList?: Array<{
        __typename?: 'CoachingFocus';
        id: string;
        name: string;
      }> | null;
    };
    subCategoryList?: Array<{
      __typename?: 'SubCategory';
      name: string;
    }> | null;
  }> | null;
  outcomes?: Array<
    | {
        __typename?: 'JobOfferInfo';
        company: {
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        };
      }
    | {
        __typename?: 'SchoolAdmissionInfo';
        status?: Types.SchoolAdmissionStatus | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }
    | { __typename?: 'TestScoreV2'; score: number; testName: string }
  > | null;
  mostRecentOrder?: {
    __typename?: 'Order';
    id: string;
    classOrder?: {
      __typename?: 'ClassOrder';
      coachingSession: {
        __typename?: 'CoachingSession';
        id: string;
        content:
          | { __typename: 'BootcampSession' }
          | { __typename: 'Class'; id: string; name?: string | null }
          | { __typename: 'EventSession' }
          | { __typename: 'OneOnOneSession' };
      };
    } | null;
    packageOrder?: {
      __typename?: 'OfferingPackage';
      id: string;
      name: string;
      visibility: Types.PackageVisibility;
      category?: { __typename?: 'Category'; id: string; name: string } | null;
    } | null;
  } | null;
  mostRecentClassSession?: {
    __typename?: 'CoachingSession';
    id: string;
    content:
      | { __typename: 'BootcampSession' }
      | {
          __typename: 'Class';
          id: string;
          name?: string | null;
          isFreeEvent?: boolean | null;
        }
      | { __typename: 'EventSession' }
      | { __typename: 'OneOnOneSession' };
  } | null;
};

export const CoachPageReviewFragmentDoc = gql`
  fragment CoachPage_Review on Review {
    id
    ...ReviewModal_Review
  }
  ${ReviewModalReviewFragmentDoc}
`;
export const CoachPageCoachFragmentDoc = gql`
  fragment CoachPage_Coach on Coach {
    id
    slug
    bio
    user {
      id
      firstName
      lastName
      pictureLink
    }
    hourlyRate
    categoryInformationList(showHidden: false) {
      category {
        id
        slug
        goal
      }
    }
    coachingRelationship {
      id
      blockedByCoach
      review {
        ...CoachPage_Review
      }
      categories {
        id
        slug
      }
    }
    packages(categorySlugOrUrn: $categorySlugOrUrn) {
      status
      ...CoachOfferings_OfferingPackage
      lelandPackageVisibility
    }
    groupClassesAndShindigs(categorySlugOrUrn: $categorySlugOrUrn) {
      ...CoachGroupClasses_AllEvents
    }
    averageReviewRate
    reviewTotal
    schoolAdmissionInfoList {
      school {
        id
        name
        logoLink
      }
      status
    }
    companiesAdmitted {
      id
      name
      domain
      logoLink
    }
    mostRecentOrder {
      id
      hourlyOrder {
        timeInMinute
      }
    }
    professionalExperiences {
      ...CoachExperience_ProfessionalExperience
    }
    educationExperiences {
      ...CoachEducation_Education
    }
    categoryInformationList(showHidden: false) {
      qualifications
      ...CoachCategories_CategoryInformation
    }
    averageFirstResponseLatency
    ...CoachBottomMessageCTA_Coach
    ...CoachInfo_Coach
    ...CoachBio_Coach
    ...CoachWhyICoach_Coach
    ...CoachQualifications_Coach
    ...CoachOfferings_Coach
    ...CoachReviews_Coach
    ...AllCoachReviewsModal_Coach
    ...CoachMessageCTA_Coach
    ...StructuredCoachData_Coach
  }
  ${CoachPageReviewFragmentDoc}
  ${CoachOfferingsOfferingPackageFragmentDoc}
  ${CoachGroupClassesAllEventsFragmentDoc}
  ${CoachExperienceProfessionalExperienceFragmentDoc}
  ${CoachEducationEducationFragmentDoc}
  ${CoachCategoriesCategoryInformationFragmentDoc}
  ${CoachBottomMessageCtaCoachFragmentDoc}
  ${CoachInfoCoachFragmentDoc}
  ${CoachBioCoachFragmentDoc}
  ${CoachWhyICoachCoachFragmentDoc}
  ${CoachQualificationsCoachFragmentDoc}
  ${CoachOfferingsCoachFragmentDoc}
  ${CoachReviewsCoachFragmentDoc}
  ${AllCoachReviewsModalCoachFragmentDoc}
  ${CoachMessageCtaCoachFragmentDoc}
  ${StructuredCoachDataCoachFragmentDoc}
`;
export const CoachPageUserFragmentDoc = gql`
  fragment CoachPage_User on User {
    id
    applicant {
      id
      hasUnassignedTrialOrder
    }
  }
`;
export const CoachPageGetCoachBySlugDocument = gql`
  query CoachPage_GetCoachBySlug(
    $coachSlug: String!
    $categorySlugOrUrn: String
    $ignoreFullSessions: Boolean = true
  ) {
    coachBySlug(slug: $coachSlug) {
      ...CoachPage_Coach
    }
  }
  ${CoachPageCoachFragmentDoc}
`;

/**
 * __useCoachPageGetCoachBySlugQuery__
 *
 * To run a query within a React component, call `useCoachPageGetCoachBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachPageGetCoachBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachPageGetCoachBySlugQuery({
 *   variables: {
 *      coachSlug: // value for 'coachSlug'
 *      categorySlugOrUrn: // value for 'categorySlugOrUrn'
 *      ignoreFullSessions: // value for 'ignoreFullSessions'
 *   },
 * });
 */
export function useCoachPageGetCoachBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoachPageGetCoachBySlugQuery,
    CoachPageGetCoachBySlugQueryVariables
  > &
    (
      | { variables: CoachPageGetCoachBySlugQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachPageGetCoachBySlugQuery,
    CoachPageGetCoachBySlugQueryVariables
  >(CoachPageGetCoachBySlugDocument, options);
}
export function useCoachPageGetCoachBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachPageGetCoachBySlugQuery,
    CoachPageGetCoachBySlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachPageGetCoachBySlugQuery,
    CoachPageGetCoachBySlugQueryVariables
  >(CoachPageGetCoachBySlugDocument, options);
}
export function useCoachPageGetCoachBySlugSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoachPageGetCoachBySlugQuery,
        CoachPageGetCoachBySlugQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachPageGetCoachBySlugQuery,
    CoachPageGetCoachBySlugQueryVariables
  >(CoachPageGetCoachBySlugDocument, options);
}
export type CoachPageGetCoachBySlugQueryHookResult = ReturnType<
  typeof useCoachPageGetCoachBySlugQuery
>;
export type CoachPageGetCoachBySlugLazyQueryHookResult = ReturnType<
  typeof useCoachPageGetCoachBySlugLazyQuery
>;
export type CoachPageGetCoachBySlugSuspenseQueryHookResult = ReturnType<
  typeof useCoachPageGetCoachBySlugSuspenseQuery
>;
export type CoachPageGetCoachBySlugQueryResult = Apollo.QueryResult<
  CoachPageGetCoachBySlugQuery,
  CoachPageGetCoachBySlugQueryVariables
>;
export const CoachPageGetHydratedCoachBySlugDocument = gql`
  query CoachPage_GetHydratedCoachBySlug($coachSlug: String!) {
    coachBySlug(slug: $coachSlug) {
      ...SaveCoachButton_SaveCoach
    }
  }
  ${SaveCoachButtonSaveCoachFragmentDoc}
`;

/**
 * __useCoachPageGetHydratedCoachBySlugQuery__
 *
 * To run a query within a React component, call `useCoachPageGetHydratedCoachBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachPageGetHydratedCoachBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachPageGetHydratedCoachBySlugQuery({
 *   variables: {
 *      coachSlug: // value for 'coachSlug'
 *   },
 * });
 */
export function useCoachPageGetHydratedCoachBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoachPageGetHydratedCoachBySlugQuery,
    CoachPageGetHydratedCoachBySlugQueryVariables
  > &
    (
      | {
          variables: CoachPageGetHydratedCoachBySlugQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachPageGetHydratedCoachBySlugQuery,
    CoachPageGetHydratedCoachBySlugQueryVariables
  >(CoachPageGetHydratedCoachBySlugDocument, options);
}
export function useCoachPageGetHydratedCoachBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachPageGetHydratedCoachBySlugQuery,
    CoachPageGetHydratedCoachBySlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachPageGetHydratedCoachBySlugQuery,
    CoachPageGetHydratedCoachBySlugQueryVariables
  >(CoachPageGetHydratedCoachBySlugDocument, options);
}
export function useCoachPageGetHydratedCoachBySlugSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoachPageGetHydratedCoachBySlugQuery,
        CoachPageGetHydratedCoachBySlugQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachPageGetHydratedCoachBySlugQuery,
    CoachPageGetHydratedCoachBySlugQueryVariables
  >(CoachPageGetHydratedCoachBySlugDocument, options);
}
export type CoachPageGetHydratedCoachBySlugQueryHookResult = ReturnType<
  typeof useCoachPageGetHydratedCoachBySlugQuery
>;
export type CoachPageGetHydratedCoachBySlugLazyQueryHookResult = ReturnType<
  typeof useCoachPageGetHydratedCoachBySlugLazyQuery
>;
export type CoachPageGetHydratedCoachBySlugSuspenseQueryHookResult = ReturnType<
  typeof useCoachPageGetHydratedCoachBySlugSuspenseQuery
>;
export type CoachPageGetHydratedCoachBySlugQueryResult = Apollo.QueryResult<
  CoachPageGetHydratedCoachBySlugQuery,
  CoachPageGetHydratedCoachBySlugQueryVariables
>;
export const CoachPageGetHourlyOrderDocument = gql`
  query CoachPage_GetHourlyOrder($id: OrderUrn!) {
    order(id: $id) {
      id
      hourlyOrder {
        timeInMinute
      }
    }
  }
`;

/**
 * __useCoachPageGetHourlyOrderQuery__
 *
 * To run a query within a React component, call `useCoachPageGetHourlyOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachPageGetHourlyOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachPageGetHourlyOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCoachPageGetHourlyOrderQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoachPageGetHourlyOrderQuery,
    CoachPageGetHourlyOrderQueryVariables
  > &
    (
      | { variables: CoachPageGetHourlyOrderQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachPageGetHourlyOrderQuery,
    CoachPageGetHourlyOrderQueryVariables
  >(CoachPageGetHourlyOrderDocument, options);
}
export function useCoachPageGetHourlyOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachPageGetHourlyOrderQuery,
    CoachPageGetHourlyOrderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachPageGetHourlyOrderQuery,
    CoachPageGetHourlyOrderQueryVariables
  >(CoachPageGetHourlyOrderDocument, options);
}
export function useCoachPageGetHourlyOrderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoachPageGetHourlyOrderQuery,
        CoachPageGetHourlyOrderQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachPageGetHourlyOrderQuery,
    CoachPageGetHourlyOrderQueryVariables
  >(CoachPageGetHourlyOrderDocument, options);
}
export type CoachPageGetHourlyOrderQueryHookResult = ReturnType<
  typeof useCoachPageGetHourlyOrderQuery
>;
export type CoachPageGetHourlyOrderLazyQueryHookResult = ReturnType<
  typeof useCoachPageGetHourlyOrderLazyQuery
>;
export type CoachPageGetHourlyOrderSuspenseQueryHookResult = ReturnType<
  typeof useCoachPageGetHourlyOrderSuspenseQuery
>;
export type CoachPageGetHourlyOrderQueryResult = Apollo.QueryResult<
  CoachPageGetHourlyOrderQuery,
  CoachPageGetHourlyOrderQueryVariables
>;
export const CoachPageGetUserDocument = gql`
  query CoachPage_GetUser {
    user {
      ...CoachPage_User
    }
  }
  ${CoachPageUserFragmentDoc}
`;

/**
 * __useCoachPageGetUserQuery__
 *
 * To run a query within a React component, call `useCoachPageGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachPageGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachPageGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoachPageGetUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CoachPageGetUserQuery,
    CoachPageGetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CoachPageGetUserQuery, CoachPageGetUserQueryVariables>(
    CoachPageGetUserDocument,
    options,
  );
}
export function useCoachPageGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachPageGetUserQuery,
    CoachPageGetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachPageGetUserQuery,
    CoachPageGetUserQueryVariables
  >(CoachPageGetUserDocument, options);
}
export function useCoachPageGetUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoachPageGetUserQuery,
        CoachPageGetUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachPageGetUserQuery,
    CoachPageGetUserQueryVariables
  >(CoachPageGetUserDocument, options);
}
export type CoachPageGetUserQueryHookResult = ReturnType<
  typeof useCoachPageGetUserQuery
>;
export type CoachPageGetUserLazyQueryHookResult = ReturnType<
  typeof useCoachPageGetUserLazyQuery
>;
export type CoachPageGetUserSuspenseQueryHookResult = ReturnType<
  typeof useCoachPageGetUserSuspenseQuery
>;
export type CoachPageGetUserQueryResult = Apollo.QueryResult<
  CoachPageGetUserQuery,
  CoachPageGetUserQueryVariables
>;
